import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { mdiLockOpenVariant, mdiLock } from '@mdi/js'
import { VIcon } from 'vuetify/components'
import { ExceptionSummaryStatus } from '@/Network/Types/Responses/StationResponses'


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusSummaryBadge',
  props: {
    status: {}
  },
  setup(__props: any) {

const props = __props;



const statusConfig = computed(() => {
  if (!props.status) return null

  switch (props.status) {
    case ExceptionSummaryStatus.APPROVED:
      return {
        label: 'Excepcionalidade aprovada',
        icon: mdiLockOpenVariant,
        iconColor: '#DA1E28',
        textColor: 'text-[#16161D]',
        containerClass: 'bg-[#FCE9EA] border-[#DA1E28]'
      }
    case ExceptionSummaryStatus.IN_PROGRESS:
      return {
        label: 'Excepcionalidade em andamento',
        icon: mdiLock,
        iconColor: '#F18F1B',
        textColor: 'text-[#16161D]',
        containerClass: 'bg-[#FEF3E7] border-[#F18F1B]'
      }
    case ExceptionSummaryStatus.IN_REVIEW:
      return {
        label: 'Excepcionalidade em revisão',
        icon: mdiLockOpenVariant,
        iconColor: '#F1C21B',
        textColor: 'text-[#16161D]',
        containerClass: 'bg-[#FEF9E7] border-[#F1C21B]'
      }
    default:
      return null
  }
})

return (_ctx: any,_cache: any) => {
  return (statusConfig.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([statusConfig.value.containerClass, "flex items-start gap-1 w-fit rounded-md border border-solid px-2 py-1"])
      }, [
        _createVNode(_unref(VIcon), {
          color: statusConfig.value.iconColor,
          size: "small",
          icon: statusConfig.value.icon
        }, null, 8, ["color", "icon"]),
        _createElementVNode("span", {
          class: _normalizeClass(["text-sm font-medium", statusConfig.value.textColor])
        }, _toDisplayString(statusConfig.value.label), 3)
      ], 2))
    : _createCommentVNode("", true)
}
}

})